<template>
  <v-btn
    :outlined="variant == 'outlined'"
    :depressed="!variant || variant == 'default'"
    :text="variant == 'text'"
    :color="color ? color : 'primary'"
    dark
    :icon="variant == 'icon'"
    @click="$emit('click', $event)"
    ><slot
  /></v-btn>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "Button",
  props: ["variant", "color"],
  data() {
    return {};
  },
});
</script>
